var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_194_716",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_194_716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5579 15.7401H11.0643V14.2438H25.5579L22.8587 11.5446L23.9172 10.4577L28.444 14.9845L23.9172 19.5113L22.8587 18.4392L25.5579 15.7401ZM18.5358 11.6416V6.40444C18.5358 6.29225 18.4988 6.20009 18.4247 6.12797C18.3505 6.05584 18.2594 6.01978 18.1512 6.01978H6.40444C6.29225 6.01978 6.20009 6.05584 6.12797 6.12797C6.05584 6.20009 6.01978 6.29225 6.01978 6.40444V23.5959C6.01978 23.7081 6.05584 23.8002 6.12797 23.8723C6.20009 23.9445 6.29225 23.9805 6.40444 23.9805H18.1512C18.2594 23.9805 18.3505 23.9445 18.4247 23.8723C18.4988 23.8002 18.5358 23.7081 18.5358 23.5959V18.3423H20.0322V23.5959C20.0322 24.111 19.8475 24.5533 19.478 24.9228C19.1086 25.2922 18.6663 25.4769 18.1512 25.4769H6.40444C5.88929 25.4769 5.447 25.2922 5.07756 24.9228C4.70815 24.5533 4.52344 24.111 4.52344 23.5959V6.40444C4.52344 5.88929 4.70815 5.447 5.07756 5.07756C5.447 4.70815 5.88929 4.52344 6.40444 4.52344H18.1512C18.6663 4.52344 19.1086 4.70815 19.478 5.07756C19.8475 5.447 20.0322 5.88929 20.0322 6.40444V11.6416H18.5358Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.50cf1e866fe3187ef20fb5524f10963d.svg";
export { ForwardRef as ReactComponent };